import type { RouteObject } from 'react-router-dom';

/**
 * CLAUDE.md §6 — Registry pattern. Har bir domen agenti faqat
 * `src/features/<domain>/routes.tsx` yaratadi va undan `routes: RouteObject[]` eksport qiladi.
 * Bu fayl ularni avtomatik yig'adi — App.tsx ga hech kim tegmaydi.
 */
const modules = import.meta.glob<{ routes: RouteObject[] }>('../features/*/routes.tsx', { eager: true });

export const featureRoutes: RouteObject[] = Object.values(modules).flatMap((m) => m.routes);
